import {EmbedCodeBase} from './types';

export const getEventPayloadForAd = ({
  containerId,
  code,
}: {
  containerId: string;
  code: EmbedCodeBase;
}) => ({
  container_id: containerId,
  creative_id: [code.params.p1, code.params.p2].join('_'),
});

/** вызывает переданный коллбек один раз */
export const once = <Args>(fn: (args: Args) => void) => {
  let called = false;
  return (args: Args) => {
    if (!called) {
      called = true;
      fn(args);
    }
  };
};
